import toSnakeCase from './toSnakeCase';

export default value => {
    const snakeCaseValue = toSnakeCase(value);

    return JSON.stringify(snakeCaseValue);
};
